import { render, staticRenderFns } from "./ParticipantList.vue?vue&type=template&id=275e785c&"
import script from "./ParticipantList.vue?vue&type=script&lang=js&"
export * from "./ParticipantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports